import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import AsyncComputed from 'vue-async-computed'
import VueCollapse from 'vue2-collapse'


Vue.use(VueCollapse)
Vue.use(AsyncComputed)

//
// const store = {
//     debug: true,
//     state: {
//         allTheValves: axios
//             .get('http://local.acs-valves/valves.json')
//             .then(response => (response.data.data))
//     },
//     setMessageAction (newValue) {
//         if (this.debug) console.log('setMessageAction triggered with', newValue)
//         this.state.message = newValue
//     },
//     clearMessageAction () {
//         if (this.debug) console.log('clearMessageAction triggered')
//         this.state.message = ''
//     }
// }

Vue.config.productionTip = false

new Vue({
    router,
    data () {
        return {
            info: null,
            valves: [],
            activeValve: {},
            testVar: "test check it out"
        }
    },

    methods: {
        changeActiveValve: function (valve) {
            //console.log(valve);
            this.activeValve = valve
        }
    },
    render: h => h(App)
}).$mount('#app')



